import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Field } from "formik";
import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  irrigationSystem,
  irrigationSystemDefaults,
} from "../../config/fieldIntialValues";

const IrrigationFormComponent = (props) => {
  const { t } = useTranslation();
  const { values, setFieldValue, errors, touched } = props?.formikProps;
  const { onSystemChange } = props;
  const [system, setSystem] = React.useState(
    values?.irrigations_system?.system,
  );

  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    if (newValue !== system) {
      setSystem(newValue);

      const defaultValues = irrigationSystemDefaults[newValue] || {
        system: newValue,
      };
      setFieldValue("irrigations_system", defaultValues);
    }
    onSystemChange?.({ system: newValue });
  };

  useEffect(() => {
    if (values?.irrigations_system) {
      onSystemChange?.(values.irrigations_system);
    }
  }, [values?.irrigations_system, onSystemChange]);

  return (
    <>
      <Stack marginY={2}>
        <Typography fontWeight="bold" fontSize="16px">
          {t("irrigation_form.h4")}
        </Typography>
        <Typography fontSize="14px" color="grey">
          {t("irrigation_form.irrigation_info_text")}
        </Typography>
      </Stack>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <FormControl
            fullWidth
            error={
              touched?.irrigations_system?.system &&
              Boolean(errors?.irrigations_system?.system)
            }
          >
            <InputLabel id="system-select-label">
              {`${t("irrigation_form.input_label")}*`}
            </InputLabel>
            <Select
              label={t("irrigation_form.select_label")}
              id="irrigations_system.system"
              name="irrigations_system.system"
              labelId="system-select-label"
              value={values?.irrigations_system?.system}
              onChange={handleSelectChange}
              error={
                touched?.irrigations_system?.system &&
                Boolean(errors?.irrigations_system?.system)
              }
            >
              <MenuItem value="">
                <em>{t("none")}</em>
              </MenuItem>
              <MenuItem value="sprinkler">{t("sprinkler")}</MenuItem>
              <MenuItem value="drip">{t("drip")}</MenuItem>
              <MenuItem value="subterranean">{t("subterranean")}</MenuItem>
              <MenuItem value="surface">{t("surface irrigation")}</MenuItem>
            </Select>
            {touched?.irrigations_system?.system &&
              errors?.irrigations_system?.system && (
                <FormHelperText error>
                  {errors?.irrigations_system?.system}
                </FormHelperText>
              )}
          </FormControl>
        </Grid>

        {irrigationSystem.sprinkler === system && (
          <Fragment>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 0 }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_sprinklers_numb")}*`}
                  name="irrigations_system.number"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.number &&
                    Boolean(errors?.irrigations_system?.number)
                  }
                  helperText={
                    touched?.irrigations_system?.number &&
                    errors?.irrigations_system?.number
                      ? errors?.irrigations_system?.number
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 0, step: "0.01" }}
                  as={TextField}
                  label={`${t(
                    "irrigation_form.field_label_spinkler_water_dispers",
                  )}*`}
                  name="irrigations_system.s_rate"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.s_rate &&
                    Boolean(errors?.irrigations_system?.s_rate)
                  }
                  helperText={
                    touched?.irrigations_system?.s_rate &&
                    errors?.irrigations_system?.s_rate
                      ? errors?.irrigations_system?.s_rate
                      : ""
                  }
                />
              </FormControl>
            </Grid>
          </Fragment>
        )}

        {irrigationSystem.drip === system && (
          <Fragment>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 1, max: 2 }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_driping_pipes")}*`}
                  name="irrigations_system.number_driping_pipes"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.number_driping_pipes &&
                    Boolean(errors?.irrigations_system?.number_driping_pipes)
                  }
                  helperText={
                    touched?.irrigations_system?.number_driping_pipes &&
                    errors?.irrigations_system?.number_driping_pipes
                      ? errors?.irrigations_system?.number_driping_pipes
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 0 }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_driping_space")}*`}
                  name="irrigations_system.space_driping_bores"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.space_driping_bores &&
                    Boolean(errors?.irrigations_system?.space_driping_bores)
                  }
                  helperText={
                    touched?.irrigations_system?.space_driping_bores &&
                    errors?.irrigations_system?.space_driping_bores
                      ? errors?.irrigations_system?.space_driping_bores
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 1, step: "0.01", max: 8 }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_water_dispens")}*`}
                  name="irrigations_system.d_rate"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.d_rate &&
                    Boolean(errors?.irrigations_system?.d_rate)
                  }
                  helperText={
                    touched?.irrigations_system?.d_rate &&
                    errors?.irrigations_system?.d_rate
                      ? errors?.irrigations_system?.d_rate
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 0 }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_wetted_length")}*`}
                  name="irrigations_system.wetted_length"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.wetted_length &&
                    Boolean(errors?.irrigations_system?.wetted_length)
                  }
                  helperText={
                    touched?.irrigations_system?.wetted_length &&
                    errors?.irrigations_system?.wetted_length
                      ? errors?.irrigations_system?.wetted_length
                      : ""
                  }
                />
              </FormControl>
            </Grid>
          </Fragment>
        )}

        {irrigationSystem.subterranean === system && (
          <Fragment>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 0 }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_depth_pipes")}*`}
                  name="irrigations_system.depth_pipes"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.depth_pipes &&
                    Boolean(errors?.irrigations_system?.depth_pipes)
                  }
                  helperText={
                    touched?.irrigations_system?.depth_pipes &&
                    errors?.irrigations_system?.depth_pipes
                      ? errors?.irrigations_system?.depth_pipes
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 1, max: 2 }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_driping_pipes")}*`}
                  name="irrigations_system.number_driping_pipes"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.number_driping_pipes &&
                    Boolean(errors?.irrigations_system?.number_driping_pipes)
                  }
                  helperText={
                    touched?.irrigations_system?.number_driping_pipes &&
                    errors?.irrigations_system?.number_driping_pipes
                      ? errors?.irrigations_system?.number_driping_pipes
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 0 }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_driping_space")}*`}
                  name="irrigations_system.spacing_dripping_bore"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.spacing_dripping_bore &&
                    Boolean(errors?.irrigations_system?.spacing_dripping_bore)
                  }
                  helperText={
                    touched?.irrigations_system?.spacing_dripping_bore &&
                    errors?.irrigations_system?.spacing_dripping_bore
                      ? errors?.irrigations_system?.spacing_dripping_bore
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 0, step: "0.01" }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_water_dispens")}*`}
                  name="irrigations_system.d_rate"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.d_rate &&
                    Boolean(errors?.irrigations_system?.d_rate)
                  }
                  helperText={
                    touched?.irrigations_system?.d_rate &&
                    errors?.irrigations_system?.d_rate
                      ? errors?.irrigations_system?.d_rate
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 0 }}
                  as={TextField}
                  label={`${t("irrigation_form.field_label_wetted_length")}*`}
                  name="irrigations_system.wetted_length"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.wetted_length &&
                    Boolean(errors?.irrigations_system?.wetted_length)
                  }
                  helperText={
                    touched?.irrigations_system?.wetted_length &&
                    errors?.irrigations_system?.wetted_length
                      ? errors?.irrigations_system?.wetted_length
                      : ""
                  }
                />
              </FormControl>
            </Grid>
          </Fragment>
        )}

        {irrigationSystem.surface_irrigation === system && (
          <Fragment>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <Field
                  type="number"
                  inputProps={{ min: 0, step: "any" }}
                  as={TextField}
                  label={`${t(
                    "irrigation_form.field_label_surface_irrigation",
                  )}*`}
                  name="irrigations_system.surface_irrigation_rate"
                  variant="outlined"
                  fullWidth
                  error={
                    touched?.irrigations_system?.surface_irrigation_rate &&
                    Boolean(errors?.irrigations_system?.surface_irrigation_rate)
                  }
                  helperText={
                    touched?.irrigations_system?.surface_irrigation_rate &&
                    errors?.irrigations_system?.surface_irrigation_rate
                      ? errors?.irrigations_system?.surface_irrigation_rate
                      : ""
                  }
                />
              </FormControl>
            </Grid>
          </Fragment>
        )}
      </Grid>
    </>
  );
};

export default IrrigationFormComponent;
